<template>
  <pnet-validation-observer>
    <div>
      <div v-if="label" class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>
              <small>{{label}}</small>
            </label>
            <pnet-input
              input-class="form-control text-left"
              label-class="text-left"
              layout="vertical"
              v-model="rawValue"
              :rules="{required:true}"
              :customMessages="{required:'Il campo deve essere valorizzato.'}"
              :name="label"
              :disabled="readonly"
            ></pnet-input>
          </div>
        </div>
      </div>
      <div v-if="!label">
        <pnet-input
          input-class="form-control text-left"
          label-class="text-left"
          layout="vertical"
          v-model="rawValue"
          :rules="{required:true}"
          :customMessages="{required:'Il campo deve essere valorizzato.'}"
          :name="''"
          :disabled="readonly"
        ></pnet-input>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import { PnetInput } from "@previnet/vue-input";
export default Vue.extend({
  props: ["label", "value", "readonly"],
  components:{
    PnetInput,
  },
  data: function() {
    return {
      rawValue: null
    }
  },
  methods: {},
  mounted() {
    this.rawValue = this.value;
  },
  watch: {
    rawValue: {
      deep:true,
      immediate: true,
      handler(){
        this.$emit('input', this.rawValue);
      }
    },
    value: {
      deep:true,
      immediate: true,
      handler(){
        this.rawValue = this.value;
      }
    }
  }
});
</script>
